import QRCode from "qrcode";
import templateImg from "@/assets/qr-poster-template.png";

const QR_SIZE = 350;
const LEFT_QR_X = 270;
const LEFT_QR_Y = 545;
const RIGHT_QR_X = 1420;
const RIGHT_QR_Y = 545;

export async function downloadQrPoster(incidentReportKey, medkitlogKey) {
  const origin = window.location.origin;

  const [incidentQr, medkitQr] = await Promise.all([
    QRCode.toDataURL(`${origin}/newIncidentReport?key=${incidentReportKey}`, {
      width: QR_SIZE,
      margin: 1,
    }),
    QRCode.toDataURL(`${origin}/newMedkitlog?key=${medkitlogKey}`, {
      width: QR_SIZE,
      margin: 1,
    }),
  ]);

  const template = await loadImage(templateImg);
  const canvas = document.createElement("canvas");
  canvas.width = template.naturalWidth;
  canvas.height = template.naturalHeight;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(template, 0, 0);

  const [leftImg, rightImg] = await Promise.all([
    loadImage(incidentQr),
    loadImage(medkitQr),
  ]);
  ctx.drawImage(leftImg, LEFT_QR_X, LEFT_QR_Y, QR_SIZE, QR_SIZE);
  ctx.drawImage(rightImg, RIGHT_QR_X, RIGHT_QR_Y, QR_SIZE, QR_SIZE);

  const link = document.createElement("a");
  link.download = "SafetyPlanner-Poster.png";
  link.href = canvas.toDataURL("image/png");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
